//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.8.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------

export interface FormMenuItem {
    translationKey: string;
    sectionName: string;
    isCompleted: boolean;
    isDetailedArray: boolean;
    hasSubmenu: boolean;
    introductionKey: string | undefined;
    arrayPath: string | undefined;
    elementTitleKey: string | undefined;
    labelAppend: string | undefined;
    labelRemove: string | undefined;
    parentSectionName: string | undefined;
}

export enum FormStatus {
    Draft = 0,
    ReadyForQA = 10,
    ReadyForPublication = 20,
    QaPending = 30,
    DispatchedForPublication = 40,
    PublishedTed = 43,
    PublishedNational = 47,
    Published = 50,
    Error = 60,
    Rejected = 70,
    Deleted = 80,
    QaCompleted = 90,
    Test = 100,
    ReadyForTranslation = 105,
    DispatchedForTranslation = 107,
    TranslationReceived = 110,
    PublicationStopped = 125,
}

export interface FormMenuResult {
    mainLanguage: string;
    formMainLanguage: string | undefined;
    additionalLanguages: string[] | undefined;
    navigationTitle: string | undefined;
    parentElementTitleKey: string | undefined;
    menuItems: FormMenuItem[] | undefined;
    isFormPreview: boolean;
    formStatus: FormStatus;
    noticeTimeZone: string | undefined;
}
